"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var CommonModule = /** @class */ (function (_super) {
    __extends(CommonModule, _super);
    function CommonModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 获取七牛云上传token
     */
    CommonModule.prototype.getUploadToken = function (privateFile, token) {
        var isPrivate = 0;
        privateFile ? (isPrivate = 1) : (isPrivate = 0);
        return this.gatewayClient.getUploadToken('OMS', isPrivate, token);
    };
    /**
     * 查询省份列表
     */
    CommonModule.prototype.queryProvinces = function () {
        return this.gatewayClient.getDistrictSelective();
    };
    /**
     * 查询城市列表
     */
    CommonModule.prototype.queryCities = function (provinceId) {
        return this.gatewayClient.getDistrictSelective(provinceId);
    };
    /**
     * 查询区县列表
     */
    CommonModule.prototype.queryCounties = function (cityId) {
        return this.gatewayClient.getDistrictSelective(cityId);
    };
    /**
     * 修改省、市、区县
     *
     *  @param isHotCity 是否为热门城市（限编辑城市时）
     *  @param id id（必传）
     *  @param order 权重值
     *  @param custName 展示名称
     *  @param cityPic 城市图片（限编辑城市时）
     */
    CommonModule.prototype.updateDistrict = function (isHotCity, id, order, custName, cityPic, token) {
        return this.gatewayClient.updateDistrict(isHotCity, id, order, custName, cityPic, token);
    };
    /**
     * 区县列表
     *
     *  @param rows 行数
     *  @param provinceId 所属省份Id
     *  @param page 页数
     *  @param sort 排序方式
     *  @param search 查询关键字
     *  @param orderBy 排序字段
     *  @param cityId 所属城市Id
     */
    CommonModule.prototype.queryDistrictCountiesWithCondition = function (params, token) {
        return this.gatewayClient.getDistrictCounties(params, token);
    };
    /**
     * 城市列表
     *
     *  @param sort 排序方式
     *  @param provinceId 所属省份Id
     *  @param page 页数
     *  @param orderBy 排序字段
     *  @param isHotCity 是否为热门城市 1是0否
     *  @param search 查询关键字
     *  @param rows 行数
     */
    CommonModule.prototype.queryDistrictCitiesWithCondition = function (params, token) {
        return this.gatewayClient.getDistrictCities(params, token);
    };
    /**
     * 省份列表
     *
     *  @param sort 排序方式
     *  @param rows 行数
     *  @param search 查询关键字
     *  @param page 页数
     *  @param orderBy 排序字段
     */
    CommonModule.prototype.queryDistrictProvincesWithCondition = function (params, token) {
        return this.gatewayClient.getDistrictProvinces(params, token);
    };
    return CommonModule;
}(gateway_module_1.GatewayModule));
exports.CommonModule = CommonModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvYXBpcy9vbXMvbW9kdWxlcy9jb21tb24vaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBRUEsb0RBQWtEO0FBRWxEO0lBQWtDLGdDQUFhO0lBQS9DOztJQW1JQSxDQUFDO0lBbElDOztPQUVHO0lBQ0kscUNBQWMsR0FBckIsVUFBc0IsV0FBb0IsRUFBRSxLQUFhO1FBQ3ZELElBQUksU0FBUyxHQUFXLENBQUMsQ0FBQztRQUMxQixXQUFXLENBQUMsQ0FBQyxDQUFDLENBQUMsU0FBUyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsR0FBRyxDQUFDLENBQUMsQ0FBQztRQUNoRCxNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxjQUFjLENBQUMsS0FBSyxFQUFFLFNBQVMsRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNwRSxDQUFDO0lBRUQ7O09BRUc7SUFDSSxxQ0FBYyxHQUFyQjtRQUNFLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLG9CQUFvQixFQUFFLENBQUM7SUFDbkQsQ0FBQztJQUVEOztPQUVHO0lBQ0ksa0NBQVcsR0FBbEIsVUFBbUIsVUFBa0I7UUFDbkMsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsb0JBQW9CLENBQUMsVUFBVSxDQUFDLENBQUM7SUFDN0QsQ0FBQztJQUVEOztPQUVHO0lBQ0ksb0NBQWEsR0FBcEIsVUFBcUIsTUFBYztRQUNqQyxNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxvQkFBb0IsQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUN6RCxDQUFDO0lBRUQ7Ozs7Ozs7O09BUUc7SUFDSSxxQ0FBYyxHQUFyQixVQUNFLFNBQWlCLEVBQ2pCLEVBQVUsRUFDVixLQUFhLEVBQ2IsUUFBZ0IsRUFDaEIsT0FBZSxFQUNmLEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxjQUFjLENBQ3RDLFNBQVMsRUFDVCxFQUFFLEVBQ0YsS0FBSyxFQUNMLFFBQVEsRUFDUixPQUFPLEVBQ1AsS0FBSyxDQUNOLENBQUM7SUFDSixDQUFDO0lBRUQ7Ozs7Ozs7Ozs7T0FVRztJQUNJLHlEQUFrQyxHQUF6QyxVQUNFLE1BUUMsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsbUJBQW1CLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQy9ELENBQUM7SUFFRDs7Ozs7Ozs7OztPQVVHO0lBQ0ksdURBQWdDLEdBQXZDLFVBQ0UsTUFRQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxpQkFBaUIsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDN0QsQ0FBQztJQUVEOzs7Ozs7OztPQVFHO0lBQ0ksMERBQW1DLEdBQTFDLFVBQ0UsTUFNQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxvQkFBb0IsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDaEUsQ0FBQztJQUNILG1CQUFDO0FBQUQsQ0FBQyxBQW5JRCxDQUFrQyw4QkFBYSxHQW1JOUM7QUFuSVksb0NBQVkifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/common/index.js
// module id = 65
// module chunks = 44